export function validCredentialsFn(email: string, password: string): boolean {
  return email.includes("@") && password.length > 0;
}
